import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import BulletinSearchResults from './BulletinSearchResults';

function AlertsSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>
        {(AgencyFilter) => <BulletinSearchResults filter={AgencyFilter} />}
      </FilterConsumer>
    </SearchMenu>
  );
}

export default AlertsSearch;
